<template>
  <div>
    <tinymce-editor
      :disabled="readonly"
      plugins="paste autoresize table"
      @onPaste="changeStyles(contextModel)"
      :init="tinyMCEInitParams"
      v-model="contextModel"
    />
  </div>
</template>

<script>
import "tinymce/tinymce.min";
//import "tinymce/skins/content/default/content.min.css";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/themes/silver/theme.min";
import "tinymce/plugins/paste/plugin.min";
import "tinymce/plugins/link/plugin.min";
import "tinymce/plugins/table/plugin.min";
import "tinymce/plugins/autoresize/plugin.min";
import editor from "@tinymce/tinymce-vue";

export default {
  name: "CustomTinymceEditor",
  components: { "tinymce-editor": editor },
  props: {
    value: { required: true },
    readonly: {
      required: false,
      default: false
    }
  },
  data: () => ({
    tinyMCEInitParams: {
      paste_webkit_styles: "color font-size background-color text-align margin padding",
      min_height: 400,
      paste_data_images: true,
      branding: false
    }
  }),
  computed: {
    contextModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", this.changeStyles(val));
      }
    }
  },
  methods: {
    changeStyles(val) {
      val = val.split('border="0"').join('border="1"');
      val = val.split("#9b2222").join("#6e6e6e");
      //this.contextModel = val;
      return val;
    }
  }
};
</script>
